<div
    class="card"
    role="region"
    aria-labelledby="profileSystemIdHeader"
    *ngIf="user"
>
    <div
        class="card-header"
        id="profileSystemIdHeader"
        role="heading"
        aria-level="2"
    >
        {{ i18n._84_SYSTEM_ACCESS | translate }}
    </div>
    <div class="card-body">
        <cmps-wait-status *ngIf="hasPendingData"></cmps-wait-status>
        <div
            class="h6 text-center"
            *ngIf="
                !hasPendingData && (!user.systemIds || !user.systemIds.length)
            "
        >
            {{ i18n._83_NO_SYSTEM_ACCESSES_CONFIGURED | translate }}
        </div>
        <div
            class="table-responsive"
            *ngIf="!hasPendingData && user.systemIds && user.systemIds.length"
        >
            <table
                class="table table-sm table-bordered-no-cells"
                aria-labelledby="profileSystemIdHeader"
            >
                <thead>
                    <tr>
                        <th>{{ i18n._87_SYSTEM_TYPE | translate }}</th>
                        <th>{{ i18n._85_SYSTEM_ID | translate }}</th>
                        <th>{{ i18n._663_SYSTEM_PARAMETER | translate }}</th>
                        <th>{{ i18n._75_START_DATE | translate }}</th>
                        <th>{{ i18n._73_END_DATE | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let i of user.systemIds">
                        <td>
                            {{
                                i.systemIdTypeId
                                    | cmpsSelectLabel
                                        : systemIdTypeOpts
                                        : 'value'
                                        : 'label'
                            }}
                        </td>
                        <td>{{ i.systemId }}</td>
                        <td>{{ i.systemParameter }}</td>
                        <td>{{ i.startDate | date: 'y-MM-dd' }}</td>
                        <td>{{ i.endDate | date: 'y-MM-dd' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
